import type { CaseRole } from '@casetrace/shared';
import type { CaseMemberListItem } from '../../lib/callables';

type MemberListProps = {
  readonly members: CaseMemberListItem[];
};

const ROLE_LABELS: Record<CaseRole, string> = {
  owner: 'Eier',
  member: 'Medlem',
  viewer: 'Leser',
};

export function MemberList({ members }: MemberListProps) {
  return (
    <section>
      <h3 className="mb-2 text-[10px] font-semibold uppercase tracking-widest text-[#3e404e]">
        Aktive
      </h3>
      <div className="flex flex-col gap-2">
        {members.map((member) => {
          const primaryLabel = member.displayName ?? member.email ?? member.userId;
          const secondaryLabel = member.displayName && member.email ? member.email : null;

          return (
            <div key={member.userId} className="rounded-md bg-white/4 px-3 py-2">
              <p className="truncate text-xs text-text-secondary">
                {primaryLabel} · {ROLE_LABELS[member.role]}
              </p>
              {secondaryLabel && (
                <p className="mt-0.5 truncate text-[11px] text-text-tertiary">{secondaryLabel}</p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
